<script setup lang="ts">
import { computed, ref } from 'vue'
import { NetworkIcon, WepinTypes } from 'wepin-vue-component'
import { defaultCoinIcon } from '@/const'

const props = withDefaults(
  defineProps<{
    tokenSrc?: string
    networkSrc?: string
    size?: WepinTypes.WepinElement['size']
    customSize?: string
  }>(),
  {
    tokenSrc: undefined,
    networkSrc: undefined,
    size: 'medium',
    customSize: '',
  },
)

const getTokenSrc = computed(() => {
  return isErrorTokenIcon.value ? defaultCoinIcon : props.tokenSrc
})
const getNetworkIconSrc = computed(() => {
  return isErrorNetworkIcon.value ? defaultCoinIcon : props.networkSrc
})

const isErrorTokenIcon = ref(false)
const onErrorTokenIcon = () => {
  isErrorTokenIcon.value = true
}
const isErrorNetworkIcon = ref(false)
const onErrorNetworkIcon = () => {
  isErrorNetworkIcon.value = true
}
</script>

<template>
  <NetworkIcon
    v-if="props.tokenSrc"
    :size="size"
    :custom-size="customSize"
    :token-src="getTokenSrc"
    :network-src="getNetworkIconSrc"
    @error:token-icon="onErrorTokenIcon"
    @error:network-icon="onErrorNetworkIcon"
  />
</template>
